import { Chip } from '@mui/material';
import HubIcon from '@mui/icons-material/Hub';
import SyncIcon from '@mui/icons-material/Sync';
import api from 'api/client';
import AdminResourceCrudPage from './components/AdminResourceCrudPage';

const AdminConnectorsPage = () => {
  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'connector_type', label: 'Type' },
    { key: 'endpoint', label: 'Endpoint' },
    {
      key: 'last_status',
      label: 'Last Status',
      render: (row) => {
        if (row.last_status === 'healthy') {
          return <Chip size="small" label="Healthy" sx={{ bgcolor: 'rgba(22,163,74,0.12)', color: '#166534', fontWeight: 600 }} />;
        }
        if (row.last_status === 'error') {
          return <Chip size="small" label="Error" sx={{ bgcolor: 'rgba(220,38,38,0.12)', color: '#991b1b', fontWeight: 600 }} />;
        }
        return <Chip size="small" label="Unknown" />;
      }
    },
    {
      key: 'last_sync_at',
      label: 'Last Sync',
      render: (row) => (row.last_sync_at ? new Date(row.last_sync_at).toLocaleString() : '-')
    }
  ];

  const fields = [
    { name: 'name', label: 'Name', type: 'text', grid: 6 },
    {
      name: 'connector_type',
      label: 'Connector Type',
      type: 'select',
      grid: 6,
      defaultValue: 'other',
      options: [
        { value: 'webhook', label: 'Webhook' },
        { value: 'jira', label: 'Jira' },
        { value: 'github', label: 'GitHub' },
        { value: 'slack', label: 'Slack' },
        { value: 'other', label: 'Other' }
      ]
    },
    { name: 'endpoint', label: 'Endpoint', type: 'text', grid: 12 },
    { name: 'auth_type', label: 'Auth Type', type: 'text', grid: 6 },
    { name: 'enabled', label: 'Enabled', type: 'switch', grid: 6, defaultValue: true },
    { name: 'auth_value', label: 'Auth Value', type: 'multiline', grid: 12 }
  ];

  const rowActions = [
    {
      label: 'Sync',
      icon: SyncIcon,
      onClick: async (row) => {
        await api.post(`/api/admin/connectors/${row.id}/sync/`, {});
      }
    }
  ];

  return (
    <AdminResourceCrudPage
      title="Connectors"
      subtitle="Manage external connector channels and synchronization states."
      icon={HubIcon}
      endpoint="/api/admin/connectors/"
      columns={columns}
      fields={fields}
      rowActions={rowActions}
    />
  );
};

export default AdminConnectorsPage;
